import type { CalendarServiceItem } from '@/types';

/**
 * One mechanic's date-only work on one day, drawn as a single whole-day entry
 * (#2760). The items share the span, so they are one block rather than N
 * overlapping ones — which would also make the row N slots tall.
 */
export interface DateOnlyDayGroup {
  id: string;
  mechanicId: string | null;
  scheduledStart: string;
  scheduledEnd: string;
  items: CalendarServiceItem[];
  totalHours: number;
}

/**
 * Separate timed segments from date-only ones and group the latter per
 * mechanic and day. Order within a group follows the input, which the
 * calendar receives ordered by `scheduled_at`.
 */
export function groupDateOnlyItems(items: readonly CalendarServiceItem[]): {
  timed: CalendarServiceItem[];
  groups: DateOnlyDayGroup[];
} {
  const timed: CalendarServiceItem[] = [];
  const byKey = new Map<string, DateOnlyDayGroup>();
  for (const item of items) {
    if (item.isDateOnly !== true) {
      timed.push(item);
      continue;
    }
    const key = `${item.assignedMechanicId ?? 'unassigned'}|${item.scheduledStart}`;
    let group = byKey.get(key);
    if (!group) {
      group = {
        id: `date-only-${key}`,
        mechanicId: item.assignedMechanicId,
        scheduledStart: item.scheduledStart,
        scheduledEnd: item.scheduledEnd,
        items: [],
        totalHours: 0,
      };
      byKey.set(key, group);
    }
    group.items.push(item);
    group.totalHours += Number(item.durationHours);
  }
  return { timed, groups: [...byKey.values()] };
}
